import { motion } from "framer-motion";
import { Phone, MessageCircle, ArrowRight } from "lucide-react";
import { whatsappLink, telLink } from "@/lib/site";
import { useLanguage } from "@/context/LanguageContext";

export const CTA = () => {
  const { t } = useLanguage();
  const go = () => document.querySelector("#booking")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section data-testid="cta" className="py-24 md:py-32 bg-foreground text-primary-foreground">
      <div className="container-x text-center max-w-3xl mx-auto">
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.1]"
        >
          {t.cta.title}
        </motion.h2>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-accent/25 border-2 border-accent/50 text-accent text-sm sm:text-base font-bold shadow-sm"
        >
          {t.cta.badge}
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
          className="mt-6 text-primary-foreground/90 font-medium text-lg sm:text-xl leading-relaxed"
        >
          {t.cta.desc}
        </motion.p>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <button data-testid="cta-booking" onClick={go} className="group inline-flex items-center gap-2.5 h-13 sm:h-14 px-8 py-4 rounded-sm bg-accent text-white text-base sm:text-lg font-bold hover:bg-accent/90 shadow-lg shadow-accent/30 transition-all cursor-pointer">
            {t.cta.bookBtn} <ArrowRight size={18} className="group-hover:translate-x-1 transition-transform" />
          </button>
          <a data-testid="cta-whatsapp" href={whatsappLink()} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2.5 h-13 sm:h-14 px-7 py-4 rounded-sm bg-[#25D366] text-white text-base sm:text-lg font-bold hover:bg-[#20b857] shadow-md transition-all">
            <MessageCircle size={18} /> WhatsApp
          </a>
          <a data-testid="cta-call" href={telLink} className="inline-flex items-center gap-2.5 h-13 sm:h-14 px-7 py-4 rounded-sm border-2 border-primary-foreground/40 text-primary-foreground text-base sm:text-lg font-bold hover:bg-primary-foreground hover:text-foreground transition-all">
            <Phone size={18} /> {t.cta.callBtn}
          </a>
        </div>
      </div>
    </section>
  );
};
